import React from 'react';

import LightBulbSVG from './assets/light-bulb-on.svg';

export const LightBulbOn = () => (
  <div data-testid="light-bulb-on">
    <img src={LightBulbSVG} alt="" />
  </div>
);
